import { signal } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { maxLengthValidator, minLengthValidator, notWhitespaceValidator } from '@utility/utility.validators';
import { NoteCardElement } from './note.model';

export class NoteCardFormGroup extends FormGroup<{
    notes: FormArray<NoteCardElementFormGroup>;
}> {
    constructor() {
        super({
            notes: new FormArray<NoteCardElementFormGroup>([]),
        });
    }

    setValueFromModel(model: NoteCardElement[]): void {
        this.controls.notes.clear();
        model.forEach((element) => {
            const control = new NoteCardElementFormGroup(element);
            this.controls.notes.push(control);
        });
    }

    getModelFromValue(): NoteCardElement[] {
        return this.controls.notes.controls
            .filter((control) => {
                return control.controls.note.value !== '';
            })
            .map((control) => {
                return control.getModelFromValue();
            })
            .filter((model) => model !== null);
    }
}

export class NoteCardElementFormGroup extends FormGroup<{ note: FormControl<string | null> }> {
    constructor(model: NoteCardElement) {
        super({
            note: new FormControl<string | null>('', [
                Validators.required,
                notWhitespaceValidator(),
                minLengthValidator(1),
                maxLengthValidator(1000),
            ]),
        });
        this.setValueFromModel(model);
    }

    public readonly valueModel = signal<NoteCardElement | null>(null);

    setValueFromModel(model: NoteCardElement): void {
        this.valueModel.set(model);

        this.setValue({
            note: model.note,
        });
    }

    getModelFromValue(): NoteCardElement {
        const model = this.valueModel()!;
        model.note = this.controls.note.value!;

        return {
            ...model,
            modifiedInitials: model.modifiedInitials || null,
            modifiedTime: model.modifiedTime || null,
        };
    }
}
